import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import LicenseCapture from "@/components/LicenseCapture";
import { Ambulance, ArrowLeft } from "lucide-react";

// Mobile-first driver's license page (front + back capture, then review-and-correct). The
// driver portal does not use the agency Layout, same as DriverAccount.
export default function DriverLicense() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-[#0A192F] text-white">
        <div className="max-w-lg mx-auto px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-md bg-[#005E82] flex items-center justify-center"><Ambulance size={18} /></div>
            <div>
              <div className="font-display font-semibold text-sm">Driver's license</div>
              <div className="text-[11px] text-slate-400 truncate max-w-[180px]">{user?.name}</div>
            </div>
          </div>
          <button onClick={() => navigate("/driver")} className="text-slate-300 text-xs flex items-center gap-1.5 hover:text-white" data-testid="driver-license-back">
            <ArrowLeft size={14} /> Back to rides
          </button>
        </div>
      </header>

      <div className="max-w-lg mx-auto px-4 pt-5 pb-24" data-testid="driver-license-page">
        <LicenseCapture onDone={() => navigate("/driver")} />
      </div>
    </div>
  );
}
